// ========== 导航和页面交互模块 ==========
import { safeStorage } from '../utils/storage.js';

// ========== "功能开发中" Toast 提示 ==========
let devToastEl = null;
let devToastTimer = null;

function showDevToast(message = '该功能正在开发中，敬请期待 🚀') {
    if (!devToastEl) {
        devToastEl = document.createElement('div');
        devToastEl.className = 'dev-toast';
        document.body.appendChild(devToastEl);
    }
    devToastEl.textContent = message;
    clearTimeout(devToastTimer);
    devToastEl.classList.remove('dev-toast-show');
    // 强制回流，确保动画重新触发
    void devToastEl.offsetWidth;
    devToastEl.classList.add('dev-toast-show');
    devToastTimer = setTimeout(() => {
        devToastEl.classList.remove('dev-toast-show');
    }, 2800);
}

// ========== 导航指示线 ==========
function initNavIndicator() {
    const nav = document.querySelector('.nav');
    const indicator = document.getElementById('navIndicator');
    if (!nav || !indicator) return;

    function moveIndicatorTo(link) {
        const navRect = nav.getBoundingClientRect();
        const linkRect = link.getBoundingClientRect();
        indicator.style.left  = (linkRect.left - navRect.left) + 'px';
        indicator.style.width = linkRect.width + 'px';
        indicator.style.opacity = '1';
    }

    // 初始定位到当前 active 链接
    const activeLink = nav.querySelector('.nav-link.active');
    if (activeLink) {
        // 等字体渲染完再测量
        requestAnimationFrame(() => moveIndicatorTo(activeLink));
    }

    // 窗口缩放时重新对齐
    window.addEventListener('resize', () => {
        const current = nav.querySelector('.nav-link.active');
        if (current) moveIndicatorTo(current);
    });

    return moveIndicatorTo;
}

// ========== 平滑滚动效果 ==========
// 没有对应 section 的导航链接显示"开发中"提示
const DEV_NAV_HREFS = [];

export function initSmoothScroll() {
    const nav = document.querySelector('.nav');
    const moveIndicatorTo = initNavIndicator();

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const href = this.getAttribute('href');
            const target = document.querySelector(href);

            // 如果是导航链接，立即切换 active + 移动指示线，0.5s 后再滚动
            const navLink = this.closest('.nav') ? this : null;
            if (navLink && nav && moveIndicatorTo) {
                nav.querySelectorAll('.nav-link').forEach(l => l.classList.remove('active'));
                navLink.classList.add('active');
                moveIndicatorTo(navLink);
            }

            if (target) {
                setTimeout(() => {
                    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 300);
            } else if (DEV_NAV_HREFS.includes(href)) {
                showDevToast();
            }
        });
    });
}

// ========== 导航栏滚动效果 ==========
export function initHeaderScroll() {
    const header = document.querySelector('.header');
    if (!header) return;

    window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;
        
        if (currentScroll > 100) {
            header.style.background = 'rgba(15, 35, 65, 0.25)';
            header.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.15)';
        } else {
            header.style.background = 'rgba(15, 35, 65, 0.15)';
            header.style.boxShadow = 'none';
        }
    });
}

// ========== 动态检测手机端路径（兼容 Vite dev server 和 Live Server）==========
function resolveMobileUrl() {
    return fetch('/site_mobile/index.html', { method: 'HEAD' })
        .then(r => r.ok ? '/site_mobile/index.html' : '/public/site_mobile/index.html')
        .catch(() => '/public/site_mobile/index.html');
}

// ========== 按钮点击事件 ==========
export function initButtonEvents() {
    const btnExplore = document.querySelector('.btn-explore');

    if (btnExplore) {
        btnExplore.addEventListener('click', () => {
            const productsSection = document.querySelector('#products');
            if (productsSection) {
                productsSection.scrollIntoView({ behavior: 'smooth' });
            } else {
                showDevToast();
            }
        });
    }

    // 水体区域内联系按钮（发送邮件）- 唤起邮件客户端
    document.querySelectorAll('.dev-btn').forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            window.location.href = 'mailto:business@birchcloudby.vip';
        });
    });

    // 切换到手机版按钮
    const btnSwitchMobile = document.getElementById('btnSwitchMobile');
    if (btnSwitchMobile) {
        btnSwitchMobile.addEventListener('click', e => {
            e.preventDefault();
            resolveMobileUrl().then(url => { window.location.href = url; });
        });
    }

    // 微信服务号弹窗（电脑端）
    initDesktopWxModal();
}

// ========== 用户提示：建议使用页面内缩放控件 ==========
export function initZoomTip() {
    const TIP_STORAGE_KEY = 'birchcloud_zoom_tip_dismissed';
    const zoomTip = document.getElementById('zoomTip');
    const zoomTipClose = document.getElementById('zoomTipClose');
    
    if (!zoomTip || !zoomTipClose) return;
    
    const dismissed = safeStorage.get('local', TIP_STORAGE_KEY);
    
    if (!dismissed) {
        setTimeout(() => {
            zoomTip.classList.add('show');
            
            setTimeout(() => {
                zoomTip.classList.remove('show');
            }, 10000);
        }, 2000);
    }
    
    zoomTipClose.addEventListener('click', () => {
        zoomTip.classList.remove('show');
        safeStorage.set('local', TIP_STORAGE_KEY, 'true');
    });
    
    zoomTip.addEventListener('click', (e) => {
        if (e.target === zoomTip) {
            zoomTip.classList.remove('show');
            safeStorage.set('local', TIP_STORAGE_KEY, 'true');
        }
    });
}

// ========== 微信服务号二维码弹窗（电脑端）==========
function initDesktopWxModal() {
    const ARTICLE_URL = 'https://mp.weixin.qq.com/s/rqKY3HKuTmuBW-z5JmX-0Q';

    const triggerBtn  = document.getElementById('desktopWxBtn');
    const overlay     = document.getElementById('wxModalOverlay');
    const modal       = document.getElementById('wxModal');
    const closeBtn    = document.getElementById('wxModalClose');
    const copyBtn     = document.getElementById('wxModalCopyBtn');
    const toast       = document.getElementById('wxModalToast');

    if (!overlay || !modal) return;

    let toastTimer = null;

    function openModal() {
        overlay.classList.add('active');
        modal.classList.add('active');
        overlay.setAttribute('aria-hidden', 'false');
        modal.setAttribute('aria-hidden', 'false');
    }

    function closeModal() {
        overlay.classList.remove('active');
        modal.classList.remove('active');
        overlay.setAttribute('aria-hidden', 'true');
        modal.setAttribute('aria-hidden', 'true');
        clearTimeout(toastTimer);
        if (toast) toast.classList.remove('show');
    }

    function copyLink() {
        function onSuccess() {
            if (!toast) return;
            clearTimeout(toastTimer);
            toast.classList.remove('show');
            void toast.offsetWidth;
            toast.classList.add('show');
            toastTimer = setTimeout(() => toast.classList.remove('show'), 3000);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(ARTICLE_URL).then(onSuccess).catch(() => {
                fallbackCopy(ARTICLE_URL);
                onSuccess();
            });
        } else {
            fallbackCopy(ARTICLE_URL);
            onSuccess();
        }
    }

    function fallbackCopy(text) {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        try { document.execCommand('copy'); } catch (e) { /* 静默失败 */ }
        document.body.removeChild(ta);
    }

    if (triggerBtn) triggerBtn.addEventListener('click', e => { e.preventDefault(); openModal(); });
    overlay.addEventListener('click', closeModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (copyBtn)  copyBtn.addEventListener('click', copyLink);

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && modal.classList.contains('active')) closeModal();
    });
}
